<template>
  <v-snackbar
    v-model="showSnackBar"
    :color="snackbarColour"
    :timeout="timeout"
    :close-on-content-click="closeOnClick"
    :class="{ 'cursor-pointer': closeOnClick }"
  >
    {{ snackbarText }}
    <template #actions>
      <v-btn
        icon="mdi-close"
        @click="showSnackBar = false"
      />
    </template>
  </v-snackbar>
</template>

<script setup>
import { useSnackbarStore } from '@/store/snackbar';
import { storeToRefs } from 'pinia';

const snackbarStore = useSnackbarStore();
let {
  snackbarText,
  snackbarColour,
  showSnackBar,
  timeout,
  closeOnClick,
} = storeToRefs(snackbarStore);

</script>
